module.exports = "/wp-content/themes/conversion/public/dist//svgs/gain-conversion.svg";